var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenProject = function SvgOpenProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2.49984C3.33333 2.0396 3.70643 1.6665 4.16667 1.6665H15.8333C16.2936 1.6665 16.6667 2.0396 16.6667 2.49984V17.4998C16.6667 17.9601 16.2936 18.3332 15.8333 18.3332H8.33333V16.6665H15V3.33317H5V7.49984H3.33333V2.49984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91074 7.74392C7.23618 7.41848 7.76382 7.41848 8.08926 7.74392L10.5893 10.2439C10.9147 10.5694 10.9147 11.097 10.5893 11.4224L3.92259 18.0891C3.76631 18.2454 3.55435 18.3332 3.33333 18.3332H0.833333C0.373096 18.3332 0 17.9601 0 17.4998V14.9998C0 14.7788 0.0877973 14.5669 0.244078 14.4106L6.91074 7.74392ZM1.66667 15.345V16.6665H2.98816L8.82149 10.8332L7.5 9.51168L1.66667 15.345Z",
    fill: "white"
  }))));
};
export { SvgOpenProject as ReactComponent };
export default __webpack_public_path__ + "assets/893f9932.svg";